module.exports = __webpack_public_path__ + "img/notification.c313532c.svg";